import { render, staticRenderFns } from "./Arttextstyle.vue?vue&type=template&id=2fd752d3&"
import script from "./Arttextstyle.vue?vue&type=script&lang=js&"
export * from "./Arttextstyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports